<template>
    <div class="image-wrapper" :style="{ 'background-image': 'url( '+ image +' )', 'background-position': horizontal+'% '+vertical+'%' }"></div>
</template>

<script>
  export default {
    props: ['blockdata'],
    name: 'image-wrapper',
    data() {
      return {
          image: this.blockdata.file.url,
          horizontal: this.blockdata.position_horizontal_image,
          vertical: this.blockdata.position_vertical_image
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ImageWrapper.vue?47e05c87